<template>
  <div class="mt-4">
    <div v-if="client">
      <h5>{{ client.full_name }}</h5>
      <div class="table-full-width table-responsive">
        <table v-if="disciplines" class="table-rating">
          <thead>
            <tr>
              <th class="col-full"></th>
              <th>Оценки</th>
              <th>Средний балл</th>
              <th>Опзданий</th>
              <th>По болезни</th>
              <th>Неув.</th>
              <th>Итог</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="discipline in disciplines" :key="discipline.id">
              <td class="col-full">
                {{ discipline.title }}
              </td>
              <td>
                <ul class="rating-list">
                  <li v-for="rating in ratingList(discipline)" :key="rating.id">
                    <span>{{ rating.value }}</span>
                  </li>
                </ul>
              </td>
              <td>
                {{ ratingAvg(ratingList(discipline)) }}
              </td>
              <td>
                {{ StatusTotal(discipline, 1) }}
              </td>
              <td>
                {{ StatusTotal(discipline, 2) }}
              </td>
              <td>
                {{ StatusTotal(discipline, 3) }}
              </td>
              <td>
                {{ ratingTotal(discipline) }}
              </td>
            </tr>
          </tbody>
        </table>
        <h5 v-else>Нет записей</h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  created() {},
  data() {
    return {
      clientDetail: null,
    };
  },
  props: ["client", "disciplines"],
  methods: {
    ratingList(discipline) {
      let ratings = [];

      for (let i = 0; i < this.client.ratings.length; i++) {
        if (this.client.ratings[i].timetable.discipline.id == discipline.id) {
          ratings.push(this.client.ratings[i]);
        }
      }
      return ratings;
    },
    ratingAvg(ratings) {
      let count = ratings.length;
      let sum = 0;
      for (let i = 0; i < count; i++) {
        sum += ratings[i].value;
      }
      if (count > 0) return (sum / count).toFixed(1);
      return (sum).toFixed(1);
    },
    ratingTotal(discipline) {
      for (let i = 0; i < this.client.process_results.length; i++) {
        if (this.client.process_results[i].discipline_id == discipline.id) {
          return this.client.process_results[i].value;
        }
      }
      return "-";
    },
    StatusTotal(discipline, status) {
      let count = 0;
      for (let i = 0; i < this.client.timetable.length; i++) {
        if (
          this.client.timetable[i].discipline_id == discipline.id &&
          this.client.timetable[i].pivot.status == status
        ) {
          count++;
        }
      }
      return count;
    },
  },
};
</script>

<style lang="scss">
.rating-list {
  margin-left: 5px;
  display: flex;

  & > li {
    cursor: pointer;
    background: red;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    padding: 0;
    margin: 0 5px 0 0;
    width: 18px;
    height: 18px;
    max-width: 18px;
    max-height: 18px;
    min-width: 18px;
    min-height: 18px;
    border: 1px solid #999;

    &.type_add {
      background: #777;
    }

    &.type_3 {
      background: green;
    }

    &.type_4 {
      background: blue;
    }

    &.type_5 {
      background: green;
    }

    & > span {
      display: block;
      color: #fff;
      font-weight: bold;
      font-size: 12px;
    }
  }
}
</style>


